"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VOICEMAIL = exports.TECH_CONSULT = exports.SMALL_GROUP_COACHING = exports.SE_DISCOVERY = exports.SELLING_OPPORTUNITY = exports.SALES_COACHING = exports.RESELL_DISCUSSION = exports.REFERRAL_TO_ANOTHER_CONTACT = exports.QUESTIONNAIRE_REVIEW_CALL = exports.QUARTERLY_REVIEW = exports.QSR_DELIVERED = exports.PROACTIVE_PROSPECTING = exports.PRICING_PACKAGING = exports.POST_SALE_SERVICES_SUPPORT = exports.PBE_REVIEW = exports.PARTIAL_DEMO = exports.OFFLINE_SOLUTION_RESEARCH = exports.OBJECTION_NO_MEETING = exports.MARKED_DOMAIN_AS_BAD_FIT = exports.KICK_OFF = exports.IN_PERSON = exports.INTERNAL_TRANSITION = exports.IMPLEMENTATION = exports.IMA = exports.GOAL_SETTING = exports.FULL_DEMO = exports.FOLLOW_UP_LATER = exports.FOLLOW_UP_CALL_SCHEDULED = exports.ESCALATION = exports.EMAIL = exports.DISCOVERY = exports.DEVELOPING_SALES_PLAN = exports.DEMO = exports.DEAL_SPECIFIC_COACHING = exports.DEAL_REVIEW = exports.CULTURE = exports.CONSULTING = exports.CLIENT_DELIVERY = exports.CANCELLATION = exports.CALL_NO_VOICEMAIL = exports.CALL = exports.BUSINESS_STRATEGY = exports.BUILD_LEAD_LIST = exports.BOOKED_MEETING = exports.BILLING_ISSUE = exports.AGENCY_SERVICES = exports.ACCOUNT_ASSIST = exports.PROSPECTING_CALL_GROUP = exports.CONNECT_CALL_GROUP = void 0;
var CONNECT_CALL_GROUP = 'CONNECT_CALL_GROUP';
exports.CONNECT_CALL_GROUP = CONNECT_CALL_GROUP;
var PROSPECTING_CALL_GROUP = 'PROSPECTING_CALL_GROUP';
exports.PROSPECTING_CALL_GROUP = PROSPECTING_CALL_GROUP;
var ACCOUNT_ASSIST = 'ACCOUNT_ASSIST';
exports.ACCOUNT_ASSIST = ACCOUNT_ASSIST;
var AGENCY_SERVICES = 'AGENCY_SERVICES';
exports.AGENCY_SERVICES = AGENCY_SERVICES;
var BILLING_ISSUE = 'BILLING_ISSUE';
exports.BILLING_ISSUE = BILLING_ISSUE;
var BOOKED_MEETING = 'BOOKED_MEETING';
exports.BOOKED_MEETING = BOOKED_MEETING;
var BUILD_LEAD_LIST = 'BUILD_LEAD_LIST';
exports.BUILD_LEAD_LIST = BUILD_LEAD_LIST;
var BUSINESS_STRATEGY = 'BUSINESS_STRATEGY';
exports.BUSINESS_STRATEGY = BUSINESS_STRATEGY;
var CALL = 'CALL';
exports.CALL = CALL;
var CALL_NO_VOICEMAIL = 'CALL_NO_VOICEMAIL';
exports.CALL_NO_VOICEMAIL = CALL_NO_VOICEMAIL;
var CANCELLATION = 'CANCELLATION';
exports.CANCELLATION = CANCELLATION;
var CLIENT_DELIVERY = 'CLIENT_DELIVERY';
exports.CLIENT_DELIVERY = CLIENT_DELIVERY;
var CONSULTING = 'CONSULTING';
exports.CONSULTING = CONSULTING;
var CULTURE = 'CULTURE';
exports.CULTURE = CULTURE;
var DEAL_REVIEW = 'DEAL_REVIEW';
exports.DEAL_REVIEW = DEAL_REVIEW;
var DEAL_SPECIFIC_COACHING = 'DEAL_SPECIFIC_COACHING';
exports.DEAL_SPECIFIC_COACHING = DEAL_SPECIFIC_COACHING;
var DEMO = 'DEMO';
exports.DEMO = DEMO;
var DEVELOPING_SALES_PLAN = 'DEVELOPING_SALES_PLAN';
exports.DEVELOPING_SALES_PLAN = DEVELOPING_SALES_PLAN;
var DISCOVERY = 'DISCOVERY';
exports.DISCOVERY = DISCOVERY;
var EMAIL = 'EMAIL';
exports.EMAIL = EMAIL;
var ESCALATION = 'ESCALATION';
exports.ESCALATION = ESCALATION;
var FOLLOW_UP_CALL_SCHEDULED = 'FOLLOW_UP_CALL_SCHEDULED';
exports.FOLLOW_UP_CALL_SCHEDULED = FOLLOW_UP_CALL_SCHEDULED;
var FOLLOW_UP_LATER = 'FOLLOW_UP_LATER';
exports.FOLLOW_UP_LATER = FOLLOW_UP_LATER;
var FULL_DEMO = 'FULL_DEMO';
exports.FULL_DEMO = FULL_DEMO;
var GOAL_SETTING = 'GOAL_SETTING';
exports.GOAL_SETTING = GOAL_SETTING;
var IMA = 'IMA';
exports.IMA = IMA;
var IMPLEMENTATION = 'IMPLEMENTATION';
exports.IMPLEMENTATION = IMPLEMENTATION;
var INTERNAL_TRANSITION = 'INTERNAL_TRANSITION';
exports.INTERNAL_TRANSITION = INTERNAL_TRANSITION;
var IN_PERSON = 'IN_PERSON';
exports.IN_PERSON = IN_PERSON;
var KICK_OFF = 'KICK_OFF';
exports.KICK_OFF = KICK_OFF;
var MARKED_DOMAIN_AS_BAD_FIT = 'MARKED_DOMAIN_AS_BAD_FIT';
exports.MARKED_DOMAIN_AS_BAD_FIT = MARKED_DOMAIN_AS_BAD_FIT;
var OBJECTION_NO_MEETING = 'OBJECTION_NO_MEETING';
exports.OBJECTION_NO_MEETING = OBJECTION_NO_MEETING;
var OFFLINE_SOLUTION_RESEARCH = 'OFFLINE_SOLUTION_RESEARCH';
exports.OFFLINE_SOLUTION_RESEARCH = OFFLINE_SOLUTION_RESEARCH;
var PARTIAL_DEMO = 'PARTIAL_DEMO';
exports.PARTIAL_DEMO = PARTIAL_DEMO;
var PBE_REVIEW = 'PBE_REVIEW';
exports.PBE_REVIEW = PBE_REVIEW;
var POST_SALE_SERVICES_SUPPORT = 'POST_SALE_SERVICES_SUPPORT';
exports.POST_SALE_SERVICES_SUPPORT = POST_SALE_SERVICES_SUPPORT;
var PRICING_PACKAGING = 'PRICING_PACKAGING';
exports.PRICING_PACKAGING = PRICING_PACKAGING;
var PROACTIVE_PROSPECTING = 'PROACTIVE_PROSPECTING';
exports.PROACTIVE_PROSPECTING = PROACTIVE_PROSPECTING;
var QSR_DELIVERED = 'QSR_DELIVERED';
exports.QSR_DELIVERED = QSR_DELIVERED;
var QUARTERLY_REVIEW = 'QUARTERLY_REVIEW';
exports.QUARTERLY_REVIEW = QUARTERLY_REVIEW;
var QUESTIONNAIRE_REVIEW_CALL = 'QUESTIONNAIRE_REVIEW_CALL';
exports.QUESTIONNAIRE_REVIEW_CALL = QUESTIONNAIRE_REVIEW_CALL;
var REFERRAL_TO_ANOTHER_CONTACT = 'REFERRAL_TO_ANOTHER_CONTACT';
exports.REFERRAL_TO_ANOTHER_CONTACT = REFERRAL_TO_ANOTHER_CONTACT;
var RESELL_DISCUSSION = 'RESELL_DISCUSSION';
exports.RESELL_DISCUSSION = RESELL_DISCUSSION;
var SALES_COACHING = 'SALES_COACHING';
exports.SALES_COACHING = SALES_COACHING;
var SELLING_OPPORTUNITY = 'SELLING_OPPORTUNITY';
exports.SELLING_OPPORTUNITY = SELLING_OPPORTUNITY;
var SE_DISCOVERY = 'SE_DISCOVERY';
exports.SE_DISCOVERY = SE_DISCOVERY;
var SMALL_GROUP_COACHING = 'SMALL_GROUP_COACHING';
exports.SMALL_GROUP_COACHING = SMALL_GROUP_COACHING;
var TECH_CONSULT = 'TECH_CONSULT';
exports.TECH_CONSULT = TECH_CONSULT;
var VOICEMAIL = 'VOICEMAIL';
exports.VOICEMAIL = VOICEMAIL;